import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { LogaltyConsentsComponent } from './logalty-consents.component';
import { MaterialModule } from '@app/material.module';
import { LogaltyConsentsRoutingModule } from './logalty-consents-routing.module';

@NgModule({
  declarations: [LogaltyConsentsComponent],
  imports: [CommonModule, MaterialModule, LogaltyConsentsRoutingModule],
  exports: [LogaltyConsentsComponent],
})
export class LogaltyConsentsModule {}
